module.exports = __webpack_public_path__ + "static/quienes-somos-2.0473bd9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/quienes-somos/images/quienes-somos-2.jpg
// module id = 530
// module chunks = 264693979713783